<ion-list class="flex flex-col gap-4">
  <ng-container *ngFor="let input of fileUploadInputs; index as i">
    <div
      *ngIf="input === 'image'"
      class="upload-wrapper"
      [class.fixed-height]="filesPreview[i]"
    >
      <label
        *ngIf="!filesPreview[i]"
        [for]="'file-' + blocIndex + '-' + i"
        class="btn"
        ><ion-icon name="add"></ion-icon>Choisir une image</label
      >
      <input
        [id]="'file-' + blocIndex + '-' + i"
        style="visibility: hidden"
        type="file"
        (change)="onFileChange($event)"
        accept="image/*"
      />
      <div *ngIf="filesPreview[i]">
        <img [src]="filesPreview[i]" class="preview" />
        <label [for]="'file-' + blocIndex + '-' + i" class="btn"
          ><ion-icon name="add"></ion-icon>Choisir une autre image</label
        >
        <ion-button (click)="removeFile(i)" class="deleteBtn">
          <ion-icon name="trash" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
    </div>
    <div
      *ngIf="input === 'pdf'"
      class="upload-wrapper pdf"
      [class.fixed-height]="filesPreview[i]"
    >
      <label
        *ngIf="!filesPreview[i]"
        [for]="'file-' + blocIndex + '-' + i"
        class="btn"
        ><ion-icon name="add"></ion-icon>Choisir un PDF</label
      >
      <input
        [id]="'file-' + blocIndex + '-' + i"
        style="visibility: hidden"
        type="file"
        (change)="onFileChange($event)"
        accept=".pdf"
      />
      <div *ngIf="filesPreview[i]">
        <iframe [src]="pdfURL(filesPreview[i])" class="preview"></iframe>
        <label [for]="'file-' + blocIndex + '-' + i" class="btn"
          ><ion-icon name="add"></ion-icon>Choisir un autre PDF</label
        >
        <ion-button (click)="removeFile(i)" class="deleteBtn">
          <ion-icon name="trash" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ng-container>
</ion-list>
